const selectors = {
    inputFields: '.section-blog-filter input',
    filterAccordionContent: '.section-blog-filter',
    buttonSubmit: '.button-submit',
    buttonReset: '.button-reset',
    filterPopupBtn: '.filter-pop-button',
    filterPopup: '.popup-filter-blog',
    closePopup: '.header-popup-filter',
    body: 'body',
    iconAmountBlogs: '.icon-amount-blogs',
    loadMore: '#AjaxinatePagination .btn',
    articleCountNumber: '.articles-count span',
    blogArticles: '.blog-articles',
    tagOfBubbles: '.carousel-cell[data-selected]',
    collectionBubbles: 'div.carousel-cell'
};

const elements = {};
for (let key in selectors) {
    elements[key] = document.querySelectorAll(selectors[key]);
}

const bubbleTags = [...elements.collectionBubbles].map(bubble => bubble.dataset.tag);

// Check if the page is a 404
const urlExists = (newURL) => {
    const http = new XMLHttpRequest();
    http.open('HEAD', newURL, false);
    http.send();
    if (http.status !== 404) {
        window.location.assign(newURL);
    } else {
        elements.articleCountNumber[0].innerText = '0';
        elements.blogArticles[0].style.display = 'none';
    }
};

// Handle set filter and redirect
const setURLandRedirect = (bubbleTag, checkBubbleTags) => {
    let arrTags = bubbleTag?.length > 1 ? [bubbleTag] : [];

    elements.inputFields.forEach(input => {
        if (input.checked && !arrTags.includes(input.name) && (!checkBubbleTags || !bubbleTags.includes(input.name))) {
            arrTags.push(input.name);
        }
    });

    if (arrTags.length > 0) {
        let newURL = window.location.href.split('/tagged')[0] + '/tagged/' + arrTags.join('+').replaceAll(' ', '-');
        urlExists(newURL);
    } else {
        window.location.href = window.location.href.split('/tagged')[0];
    }
};

// Handle click on collection bubbles
elements.collectionBubbles.forEach(bubble => {
    let initialX, initialY;
    const tolerance = 5;

    bubble.addEventListener('mousedown', event => {
        initialX = event.clientX;
        initialY = event.clientY;
    });

    bubble.addEventListener('mouseup', event => {
        if (Math.abs(event.clientX - initialX) < tolerance && Math.abs(event.clientY - initialY) < tolerance) {
            setURLandRedirect(event.target.dataset.tag, true);
        }
    });
});

// Handle button submit
elements.buttonSubmit[0].addEventListener('click', () => {
    setURLandRedirect(elements.tagOfBubbles[0]?.dataset.tag || '', false);
});

// Handle button reset
elements.buttonReset[0].addEventListener('click', () => {
    window.location.assign(window.location.href.split('/tagged')[0]);
});

// Show filter pop up - mobile
const togglePopup = (show) => {
    elements.filterPopup[0].style.display = show ? 'block' : 'none';
    elements.filterAccordionContent[0].classList.toggle('section-blog-filter-mobile', show);
    elements.body[0].classList.toggle('disable-scrolling', show);
};

elements.filterPopupBtn[0].addEventListener('click', () => togglePopup(true));
elements.closePopup[0].addEventListener('click', () => togglePopup(false));
elements.filterPopup[0].addEventListener('click', () => togglePopup(false));